import { Box, Flex } from '@chakra-ui/react'
import Footer from './Footer'

const Container = ({ children, ...props }) => {
  return (
    <Flex direction='column' minHeight='100vh' alignItems='center'>
      <Box as='main' w='100%' maxW='36.375rem'>
        {children}
      </Box>

      <Footer />
    </Flex>
  )
}

export default Container
